<template>
  <vxe-modal ref="modal" v-model="visible" title="导出信息" width="800px">
    <el-form ref="FormRef" size="mini" :rules="rules" :model="form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="供方" prop="supplier">
            <!-- <el-input placeholder="输入" v-model="form.supplier" clearable /> -->
            <el-autocomplete
              v-model="form.supplier"
              :fetch-suggestions="querySearchSupplier"
              placeholder="输入"
              clearable
              @change="supplierChange"
              @select="supplierChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系人" prop="supplierContact">
            <!-- <el-input placeholder="输入" v-model="form.supplierContact" clearable /> -->
            <el-autocomplete
              v-model="form.supplierContact"
              :fetch-suggestions="querySearchSupplierContact"
              placeholder="输入"
              clearable
              @change="supplierContactChange"
              @select="supplierContactChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系方式" prop="supplierTel">
            <!-- <el-input placeholder="输入" v-model="form.supplierTel" clearable /> -->
            <el-autocomplete
              v-model="form.supplierTel"
              :fetch-suggestions="querySearchSupplierTel"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需方" prop="required">
            <!-- <el-input placeholder="输入" v-model="form.required" clearable /> -->
            <el-autocomplete
              v-model="form.required"
              :fetch-suggestions="querySearchRequired"
              placeholder="输入"
              clearable
              @change="requiredChange"
              @select="requiredChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系人" prop="requiredContact">
            <!-- <el-input placeholder="输入" v-model="form.requiredContact" clearable /> -->
            <el-autocomplete
              v-model="form.requiredContact"
              :fetch-suggestions="querySearchRequiredContact"
              placeholder="输入"
              clearable
              @change="requiredContactChange"
              @select="requiredContactChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系方式" prop="requiredTel">
            <!-- <el-input placeholder="输入" v-model="form.requiredTel" clearable /> -->
            <el-autocomplete
              v-model="form.requiredTel"
              :fetch-suggestions="querySearchRequiredTel"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <YKDivider>
        其他信息
      </YKDivider>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="报价日期" prop="quotationDate">
            <el-date-picker
              type="date"
              placeholder="输入"
              value-format="yyyy-MM-dd"
              v-model="form.quotationDate"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报价有效期" prop="validityPeriod">
            <!-- <el-input placeholder="输入" v-model="form.validityPeriod" clearable /> -->
            <el-autocomplete
              v-model="form.validityPeriod"
              :fetch-suggestions="querySearchValidityPeriod"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <!-- <el-input placeholder="输入" v-model="form.creditCode" clearable /> -->
            <el-autocomplete
              v-model="form.creditCode"
              :fetch-suggestions="querySearchCreditCode"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="住所" prop="address">
            <!-- <el-input placeholder="输入" v-model="form.address" clearable /> -->
            <el-autocomplete
              v-model="form.address"
              :fetch-suggestions="querySearchAddress"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="法定代表人" prop="legalRepresentative">
            <!-- <el-input placeholder="输入" v-model="form.legalRepresentative" clearable /> -->
            <el-autocomplete
              v-model="form.legalRepresentative"
              :fetch-suggestions="querySearchLegalRepresentative"
              placeholder="输入"
              clearable
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin-top: 10px;display: flex;justify-content: flex-end">
      <el-button @click="closeModal()">取消</el-button>
      <el-button type="primary" @click="sure()">确认</el-button>
    </div>
  </vxe-modal>
</template>
<script>
import YKDivider from '../../components/common/YKDivider.vue'
export default {
  components: {
    YKDivider
  },
  data() {
    return {
      visible: false,
      form: {
        supplier: '',
        supplierContact: '',
        supplierTel: '',
        required: '',
        requiredContact: '',
        requiredTel: '',
        quotationDate: '',
        validityPeriod: '',
        creditCode: '',
        address: '',
        legalRepresentative: ''
      },
      rules: {},
      // 最后一次导出的内容
      lastContent: {
        supplier: '',
        supplierContact: '',
        supplierTel: '',
        required: '',
        requiredContact: '',
        requiredTel: '',
        quotationDate: '',
        validityPeriod: '',
        creditCode: '',
        address: '',
        legalRepresentative: ''
      },
      // 历史记录
      historyCombobox: {
        supplier: [],
        required: [],
        validityPeriod: [],
        creditCode: [],
        address: [],
        legalRepresentative: []
      }
    }
  },
  mounted() {
    // 获取storage
    try {
      const historyCombobox = window.localStorage.getItem(`${this.$store.state.userInfo.userId}-historyCombobox`)
      if (historyCombobox) {
        this.historyCombobox = JSON.parse(historyCombobox)
      }
    } catch {
      console.error('获取storage失败')
    }
  },
  methods: {
    // 供方改变
    supplierChange(back) {
      let str = this.$utils.isString(back) ? back : back.value
      if (!str) {
        this.form.supplierContact = ''
        this.form.supplierTel = ''
      } else {
        const supplier = this.historyCombobox.supplier.find(item => item.supplier === str)
        if (supplier) {
          this.form.supplierContact = supplier.supplierContact
          this.form.supplierTel = supplier.supplierTel
        }
      }
    },
    // 供方联系人改变
    supplierContactChange(back) {
      let str = this.$utils.isString(back) ? back : back.value
      if (!str) {
        this.form.supplierTel = ''
      } else {
        const supplier = this.historyCombobox.supplier.find(
          item => item.supplier === this.form.supplier && item.supplierContact === str
        )
        if (supplier) {
          this.form.supplierTel = supplier.supplierTel
        }
      }
    },
    // 需方改变
    requiredChange(back) {
      let str = this.$utils.isString(back) ? back : back.value
      if (!str) {
        this.form.requiredContact = ''
        this.form.requiredTel = ''
      } else {
        const required = this.historyCombobox.required.find(item => item.required === str)
        if (required) {
          this.form.requiredContact = required.requiredContact
          this.form.requiredTel = required.requiredTel
        }
      }
    },
    // 需方联系人改变
    requiredContactChange(back) {
      let str = this.$utils.isString(back) ? back : back.value
      if (!str) {
        this.form.requiredTel = ''
      } else {
        const required = this.historyCombobox.required.find(
          item => item.required === this.form.required && item.requiredContact === str
        )
        if (required) {
          this.form.requiredTel = required.requiredTel
        }
      }
    },
    // 联想下拉框 - 报价有效期
    querySearchValidityPeriod(queryString, cb) {
      let validityPeriodList = this.historyCombobox.validityPeriod
      // 数据清洗
      validityPeriodList = validityPeriodList.filter(item => !!item)
      let results = queryString
        ? validityPeriodList.filter(item => String(item).includes(queryString))
        : validityPeriodList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 统一社会信用代码
    querySearchCreditCode(queryString, cb) {
      let creditCodeList = this.historyCombobox.creditCode
      // 数据清洗
      creditCodeList = creditCodeList.filter(item => !!item)
      let results = queryString ? creditCodeList.filter(item => String(item).includes(queryString)) : creditCodeList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 住所
    querySearchAddress(queryString, cb) {
      let addressList = this.historyCombobox.address
      // 数据清洗
      addressList = addressList.filter(item => !!item)
      let results = queryString ? addressList.filter(item => String(item).includes(queryString)) : addressList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 住所
    querySearchLegalRepresentative(queryString, cb) {
      let legalRepresentativeList = this.historyCombobox.legalRepresentative
      // 数据清洗
      legalRepresentativeList = legalRepresentativeList.filter(item => !!item)
      let results = queryString
        ? legalRepresentativeList.filter(item => String(item).includes(queryString))
        : legalRepresentativeList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 供方
    querySearchSupplier(queryString, cb) {
      let supplierList = this.historyCombobox.supplier
      supplierList = supplierList.map(item => item.supplier)
      // 数据清洗
      supplierList = supplierList.filter(item => !!item)
      let results = queryString ? supplierList.filter(item => String(item).includes(queryString)) : supplierList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 供方联系人
    querySearchSupplierContact(queryString, cb) {
      let supplierList = this.historyCombobox.supplier
      // 数据清洗
      if (this.form.supplier) {
        supplierList = supplierList.filter(item => item.supplier === this.form.supplier)
        supplierList = supplierList.map(item => item.supplierContact)
        supplierList = supplierList.filter(item => !!item)
        let results = queryString ? supplierList.filter(item => String(item).includes(queryString)) : supplierList
        results = results.map(item => ({ value: item }))
        cb(results)
      } else {
        cb([])
      }
    },
    // 联想下拉框 - 供方联系电话
    querySearchSupplierTel(queryString, cb) {
      let supplierList = this.historyCombobox.supplier
      // 数据清洗
      if (this.form.supplier && this.form.supplierContact) {
        supplierList = supplierList.filter(
          item => item.supplier === this.form.supplier && item.supplierContact === this.form.supplierContact
        )
        supplierList = supplierList.map(item => item.supplierTel)
        supplierList = supplierList.filter(item => !!item)
        let results = queryString ? supplierList.filter(item => String(item).includes(queryString)) : supplierList
        results = results.map(item => ({ value: item }))
        cb(results)
      } else {
        cb([])
      }
    },
    // 联想下拉框 - 需方
    querySearchRequired(queryString, cb) {
      let requiredList = this.historyCombobox.required
      requiredList = requiredList.map(item => item.required)
      // 数据清洗
      requiredList = requiredList.filter(item => !!item)
      let results = queryString ? requiredList.filter(item => String(item).includes(queryString)) : requiredList
      results = results.map(item => ({ value: item }))
      cb(results)
    },
    // 联想下拉框 - 需方联系人
    querySearchRequiredContact(queryString, cb) {
      let requiredList = this.historyCombobox.required
      // 数据清洗
      if (this.form.required) {
        requiredList = requiredList.filter(item => item.required === this.form.required)
        requiredList = requiredList.map(item => item.requiredContact)
        requiredList = requiredList.filter(item => !!item)
        let results = queryString ? requiredList.filter(item => String(item).includes(queryString)) : requiredList
        results = results.map(item => ({ value: item }))
        cb(results)
      } else {
        cb([])
      }
    },
    // 联想下拉框 - 需方联系电话
    querySearchRequiredTel(queryString, cb) {
      let requiredList = this.historyCombobox.required
      // 数据清洗
      if (this.form.required && this.form.requiredContact) {
        requiredList = requiredList.filter(
          item => item.required === this.form.required && item.requiredContact === this.form.requiredContact
        )
        requiredList = requiredList.map(item => item.requiredTel)
        requiredList = requiredList.filter(item => !!item)
        let results = queryString ? requiredList.filter(item => String(item).includes(queryString)) : requiredList
        results = results.map(item => ({ value: item }))
        cb(results)
      } else {
        cb([])
      }
    },
    // 处理历史记录
    handleHistory() {
      // 判断是否有本次的历史记录, 如果已有则移动至最前
      const form = JSON.parse(JSON.stringify(this.form))

      // 供方设置
      const supplier = {
        supplier: form.supplier,
        supplierContact: form.supplierContact,
        supplierTel: form.supplierTel
      }
      if (
        this.historyCombobox.supplier.find(
          item =>
            item.supplier === supplier.supplier &&
            item.supplierContact === supplier.supplierContact &&
            item.supplierTel === supplier.supplierTel
        )
      ) {
        this.historyCombobox.supplier = this.historyCombobox.supplier.filter(
          item =>
            item.supplier !== supplier.supplier &&
            item.supplierContact !== supplier.supplierContact &&
            item.supplierTel !== supplier.supplierTel
        )
        this.historyCombobox.supplier.unshift(supplier)
      } else {
        this.historyCombobox.supplier.unshift(supplier)
      }

      // 需方设置
      const required = {
        required: form.required,
        requiredContact: form.requiredContact,
        requiredTel: form.requiredTel
      }
      if (
        this.historyCombobox.required.find(
          item =>
            item.required === required.required &&
            item.requiredContact === required.requiredContact &&
            item.requiredTel === required.requiredTel
        )
      ) {
        this.historyCombobox.required = this.historyCombobox.required.filter(
          item =>
            item.required !== required.required &&
            item.requiredContact !== required.requiredContact &&
            item.requiredTel !== required.requiredTel
        )
        this.historyCombobox.required.unshift(required)
      } else {
        this.historyCombobox.required.unshift(required)
      }

      // 有效期设置
      if (this.historyCombobox.validityPeriod.includes(form.validityPeriod)) {
        this.historyCombobox.validityPeriod = this.historyCombobox.validityPeriod.filter(
          item => item !== form.validityPeriod
        )
        this.historyCombobox.validityPeriod.unshift(form.validityPeriod)
      } else {
        this.historyCombobox.validityPeriod.unshift(form.validityPeriod)
      }
      this.historyCombobox.validityPeriod = this.historyCombobox.validityPeriod.filter(item => !!item)

      // 统一社会信用代码设置
      if (this.historyCombobox.creditCode.includes(form.creditCode)) {
        this.historyCombobox.creditCode = this.historyCombobox.creditCode.filter(item => item !== form.creditCode)
        this.historyCombobox.creditCode.unshift(form.creditCode)
      } else {
        this.historyCombobox.creditCode.unshift(form.creditCode)
      }
      this.historyCombobox.creditCode = this.historyCombobox.creditCode.filter(item => !!item)

      // 住所设置
      if (this.historyCombobox.address.includes(form.address)) {
        this.historyCombobox.address = this.historyCombobox.address.filter(item => item !== form.address)
        this.historyCombobox.address.unshift(form.address)
      } else {
        this.historyCombobox.address.unshift(form.address)
      }
      this.historyCombobox.address = this.historyCombobox.address.filter(item => !!item)

      // 法定代表人设置
      if (this.historyCombobox.legalRepresentative.includes(form.legalRepresentative)) {
        this.historyCombobox.legalRepresentative = this.historyCombobox.legalRepresentative.filter(
          item => item !== form.legalRepresentative
        )
        this.historyCombobox.legalRepresentative.unshift(form.legalRepresentative)
      } else {
        this.historyCombobox.legalRepresentative.unshift(form.legalRepresentative)
      }
      this.historyCombobox.legalRepresentative = this.historyCombobox.legalRepresentative.filter(item => !!item)

      // 保存历史记录
      window.localStorage.setItem(
        `${this.$store.state.userInfo.userId}-historyCombobox`,
        JSON.stringify(this.historyCombobox)
      )
    },
    sure() {
      const form = JSON.parse(JSON.stringify(this.form))

      // 记录最后一次导出的内容到storage
      window.localStorage.setItem(`${this.$store.state.userInfo.userId}-lastContent`, JSON.stringify(form))

      // 历史记录处理
      this.handleHistory()

      this.$emit('sure', form)
      this.closeModal()
    },
    openModal() {
      this.form = {
        supplier: '',
        supplierContact: '',
        supplierTel: '',
        required: '',
        requiredContact: '',
        requiredTel: '',
        quotationDate: this.ykDateFormat('yyyy-MM-dd', new Date()),
        validityPeriod: '',
        creditCode: '',
        address: '',
        legalRepresentative: ''
      }

      // 获取storage
      try {
        const lastContent = window.localStorage.getItem(`${this.$store.state.userInfo.userId}-lastContent`)
        if (lastContent) {
          this.form = JSON.parse(lastContent)
        }
      } catch {
        console.error('获取storage失败')
      }

      // 报价日期单独处理 - 默认为当前日期
      this.form.quotationDate = this.ykDateFormat('yyyy-MM-dd', new Date())

      this.visible = true
    },
    closeModal() {
      this.visible = false
    }
  },
  computed: {}
}
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 5px;
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}

.el-autocomplete {
  width: 100%;
}
</style>
